import { Text, Timeline } from "@mantine/core";
import React from "react";
import { HiArrowsExpand } from "react-icons/hi";
function Career() {
  return (
    <div className="margin_container">
      <div className="about-career-section">

        <div className="all-items">

        <div className="education">
          <h3>  <HiArrowsExpand/> Educational Background</h3>

          <div className="timeline_area">
            <Timeline
              color="violet"
              radius="lg"
              active={3}
              lineWidth={8}
              bulletSize={16}
            >
              <Timeline.Item title="Secondary School Certificate">
                <Text color="dimmed" size="sm">
                  I &apos;ve completed ssc from KKH school.
                </Text>
                <Text size="xs" mt={4}>
                  passing year 2017
                </Text>
              </Timeline.Item>

              <Timeline.Item title="Higher Secondary School Certificate">
                <Text color="dimmed" size="sm">
                In 2019 I've finished my Intermediate /HSC at Science College in Gazipur, Dhaka.
                </Text>
                <Text size="xs" mt={4}>
                  passing year 2019
                </Text>
              </Timeline.Item>

              <Timeline.Item title="Honours degree">
                <Text color="dimmed" size="sm">
                Currently, I'm studying B. A Honours in English language and literature at the National University of Bangladesh.
                </Text>
                <Text size="xs" mt={4}>
                  studying from 2019 to --
                </Text>
              </Timeline.Item>
            </Timeline>
          </div>
        </div>
        <div className="technology">
      
          <h3>  <HiArrowsExpand/>Technoloy Object</h3>

          <div className="timeline_area">
            <Timeline
              color="yellow"
              radius="lg"
              active={3}
              lineWidth={8}
              bulletSize={16}
            >
              <Timeline.Item title="MERN stack course">
                <Text color="dimmed" size="sm">
                I have completed the MERN stack development course from Programming Hero. One of the best IT institutions in Bangladesh. Here I  have learned modern javascript frameworks like React.js for Frontend and Nodejs for backed development. And also learned how to work on a team-based project remotely.
                </Text>
                <Text size="xs" mt={4}>
                 completed in 2019
                </Text>
              </Timeline.Item>

              <Timeline.Item title="Wordpress Design and Development">
                <Text color="dimmed" size="sm">
                I have completed a WordPress design and development course from Topper IT which is one of the best WordPress learning institutions in Bangladesh. From there I learned a lot of core concepts of WordPress.
                </Text>
                <Text size="xs" mt={4}>
                  completed in 2020
                </Text>
              </Timeline.Item>

            
            </Timeline>
          </div>
        </div>
        <div className="job">
 
          <h3>  <HiArrowsExpand/>Job experience</h3>
          <div className="timeline_area">
            <Timeline
              color="teal"
              radius="lg"
              active={3}
              lineWidth={8}
              bulletSize={16}
            >

            <Timeline.Item title="Intership">
                <Text color="dimmed" size="sm">
                I was an intern at a bd tech firm as a frontend developer.
                </Text>
                <Text size="xs" mt={4}>
                 left 2020
                </Text>
              </Timeline.Item>
              <Timeline.Item title="Frontend developer">
                <Text color="dimmed" size="sm">
                I was a former full-stack developer at SoftDevs IT institute almost half a year ago.
                </Text>
                <Text size="xs" mt={4}>
                 left 2021
                </Text>
              </Timeline.Item>


            
            </Timeline>
          </div>
        </div>

        </div>
      
      </div>
    </div>
  );
}

export default Career;
